import type { ProviderId } from "../../../types/lifecycle.ts";

const PAYMENT_PAGES: ProviderId[] = ["ozk", "dzi", "generali", "levins"];

/** The installment payment page for a policy, or null where none exists yet. */
export const paymentPagePath = (
  provider: ProviderId,
  policyNumber: string
): string | null =>
  PAYMENT_PAGES.includes(provider)
    ? `/integrations/${provider}/payments?policy=${encodeURIComponent(
        policyNumber
      )}`
    : null;
